/**
 * React component URL resolver for the SPA navigation engine.
 *
 * The mount-time resolution happens inside the core mount coordinator
 * via `@sdx/core/mount`'s component-resolver; this navigation-time
 * resolver always goes through drupalSettings.sdx_react. Registered on
 * `Drupal.sdxNavigation` by mount.ts.
 */

import { createNavigationComponentResolver } from '@sdx/core/mount';
import { readReactSettings } from './types';

export const resolveComponentUrlForNavigation = createNavigationComponentResolver(readReactSettings, '[SDX React]');
